// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Consent sent → accepted → patient created; each step lights up green when done. */
.LeadTaskDetail-module__outcomeStrip___fI9Na {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 16px;
  margin: 0 16px 12px;
  padding: 10px 12px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fafafa;
}

.LeadTaskDetail-module__outcomeStep___bKqYq {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #71717a;
  font-size: 12px;
  font-weight: 500;
}

.LeadTaskDetail-module__outcomeStepDone___Zlb4m {
  color: #166534;
  font-weight: 600;
}

.LeadTaskDetail-module__outcomeMark___F__dx {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #d4d4d8;
  font-size: 10px;
  line-height: 1;
}

.LeadTaskDetail-module__outcomeStepDone___Zlb4m .LeadTaskDetail-module__outcomeMark___F__dx {
  border-color: #86efac;
  background: #dcfce7;
  color: #166534;
}

.LeadTaskDetail-module__outcomeDetail___FiXJL {
  color: #71717a;
  font-weight: 400;
}

.LeadTaskDetail-module__outcomeHint___TY1KL {
  color: #8a5a1a;
  font-size: 12px;
  font-weight: 500;
}

.LeadTaskDetail-module__outcomeCompleteButton___BeBBq {
  margin-left: auto;
  padding: 5px 12px;
  border: none;
  border-radius: 6px;
  background: #166534;
  color: #f0fdf4;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.LeadTaskDetail-module__outcomeCompleteButton___BeBBq:disabled {
  cursor: default;
  opacity: 0.6;
}

.LeadTaskDetail-module__outcomeCompleteButton___BeBBq + .LeadTaskDetail-module__outcomePatientLink___vLSgh {
  margin-left: 0;
}

.LeadTaskDetail-module__outcomePatientLink___vLSgh {
  margin-left: auto;
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  background: #166534;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(22, 101, 52, 0.18);
}

.LeadTaskDetail-module__outcomePatientLink___vLSgh:hover {
  background: #14532d;
}

.LeadTaskDetail-module__consentLink___xGZg0 {
  color: #18181b;
  text-decoration: underline;
  text-underline-offset: 2px;
  word-break: break-all;
}

.LeadTaskDetail-module__consentLink___xGZg0:hover {
  color: #3f3f46;
}

.LeadTaskDetail-module__consentLinkSpent___rzOri {
  color: #a1a1aa;
  word-break: break-all;
}

.LeadTaskDetail-module__consentActions___bP13V {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/LeadTaskDetail/LeadTaskDetail.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB,oFAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,8CAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,0BAAA;EACA,0BAAA;EACA,qBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,qBAAA;AAAF;;AAGA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAAF","sourcesContent":["// Only the lead-specific bits live here; everything else reuses TaskDetail.module.scss.\n\n/* Consent sent → accepted → patient created; each step lights up green when done. */\n.outcomeStrip {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 16px;\n  margin: 0 16px 12px;\n  padding: 10px 12px;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  background: #fafafa;\n}\n\n.outcomeStep {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #71717a;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.outcomeStepDone {\n  color: #166534;\n  font-weight: 600;\n}\n\n.outcomeMark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 1px solid #d4d4d8;\n  font-size: 10px;\n  line-height: 1;\n}\n\n.outcomeStepDone .outcomeMark {\n  border-color: #86efac;\n  background: #dcfce7;\n  color: #166534;\n}\n\n.outcomeDetail {\n  color: #71717a;\n  font-weight: 400;\n}\n\n.outcomeHint {\n  color: #8a5a1a;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.outcomeCompleteButton {\n  margin-left: auto;\n  padding: 5px 12px;\n  border: none;\n  border-radius: 6px;\n  background: #166534;\n  color: #f0fdf4;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.outcomeCompleteButton:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n\n.outcomeCompleteButton + .outcomePatientLink {\n  margin-left: 0;\n}\n\n.outcomePatientLink {\n  margin-left: auto;\n  padding: 10px 18px;\n  border: none;\n  border-radius: 8px;\n  background: #166534;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  text-decoration: none;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(22, 101, 52, 0.18);\n}\n\n.outcomePatientLink:hover {\n  background: #14532d;\n}\n\n.consentLink {\n  color: #18181b;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  word-break: break-all;\n}\n\n.consentLink:hover {\n  color: #3f3f46;\n}\n\n.consentLinkSpent {\n  color: #a1a1aa;\n  word-break: break-all;\n}\n\n.consentActions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outcomeStrip": `LeadTaskDetail-module__outcomeStrip___fI9Na`,
	"outcomeStep": `LeadTaskDetail-module__outcomeStep___bKqYq`,
	"outcomeStepDone": `LeadTaskDetail-module__outcomeStepDone___Zlb4m`,
	"outcomeMark": `LeadTaskDetail-module__outcomeMark___F__dx`,
	"outcomeDetail": `LeadTaskDetail-module__outcomeDetail___FiXJL`,
	"outcomeHint": `LeadTaskDetail-module__outcomeHint___TY1KL`,
	"outcomeCompleteButton": `LeadTaskDetail-module__outcomeCompleteButton___BeBBq`,
	"outcomePatientLink": `LeadTaskDetail-module__outcomePatientLink___vLSgh`,
	"consentLink": `LeadTaskDetail-module__consentLink___xGZg0`,
	"consentLinkSpent": `LeadTaskDetail-module__consentLinkSpent___rzOri`,
	"consentActions": `LeadTaskDetail-module__consentActions___bP13V`
};
module.exports = ___CSS_LOADER_EXPORT___;
